QuantityOnHandFieldController.$inject = ['$scope']
function QuantityOnHandFieldController($scope) {
  const quantityOnHand = $scope.model.QuantityOnHand

  const templateOptions = $scope.to

  const text = quantityOnHand ? quantityOnHand.toString() : ''
  const label = templateOptions.helpLabel ? templateOptions.helpLabel : 'Max'
  $scope.to.helpText = $scope.model.QuantityOnHand !== Number.MAX_VALUE ?`${label}: ${text}` :''
}

export default QuantityOnHandFieldController